<template>
  <div id="project">
    <!-- <div class="page-banner0">
      <img class="bg-img" :src="banner.imgUrl">
    </div> -->
    <router-view></router-view>
  </div>
</template>

<script>
//import {getBannersByColId} from '@/api/project'

export default {
  data() {
    return {
    }
  },
  mounted() {
    this.$store.commit('setCurrentMenuI', 1)
  }
}
</script>
